import { Link } from "react-router-dom";
import { homePage } from "@/mocks/home";
import ScrollReveal from "@/components/feature/ScrollReveal";

export default function HomeHighlights() {
  const { highlights } = homePage;

  const icons = [
    { icon: "ri-fire-line", label: "現烤香氣" },
    { icon: "ri-star-fill", label: "厚實內餡" },
    { icon: "ri-heart-3-line", label: "品牌溫度" },
  ];

  const images = [
    "https://readdy.ai/api/search-image?query=steam%20rising%20from%20freshly%20baked%20taiyaki%20red%20bean%20cakes%20on%20griddle%20warm%20golden%20light%20close-up%20food%20photography%20artisan%20Taiwanese%20street%20snack%20aromatic%20warm%20atmosphere%20amber%20bokeh%20background%20appetizing&width=600&height=400&seq=home-hl-1&orientation=landscape",
    "https://readdy.ai/api/search-image?query=cross%20section%20of%20red%20bean%20cake%20showing%20thick%20filling%20inside%20golden%20crispy%20shell%20close-up%20macro%20food%20photography%20warm%20cream%20background%20artisan%20handmade%20Japanese%20street%20food%20appetizing%20thick%20filling&width=600&height=400&seq=home-hl-2&orientation=landscape",
    "https://readdy.ai/api/search-image?query=warm%20scene%20of%20Taiwanese%20street%20food%20vendor%20handing%20red%20bean%20cake%20to%20customer%20cozy%20atmosphere%20warm%20golden%20lighting%20friendly%20interaction%20everyday%20happiness%20documentary%20style%20photography&width=600&height=400&seq=home-hl-3&orientation=landscape",
  ];

  return (
    <section className="py-16 md:py-20 bg-redbean-lightcream">
      <div className="mx-auto px-4 md:px-6 lg:px-8" style={{ maxWidth: "1200px" }}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {highlights.cards.map((card, idx) => (
            <ScrollReveal key={idx} delay={idx * 120}>
              <div
                className="bg-white rounded-card overflow-hidden shadow-soft hover:shadow-card transition-shadow duration-300 group"
              >
                <div className="w-full" style={{ height: "200px" }}>
                  <img
                    src={images[idx]}
                    alt={icons[idx].label}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-redbean-primary/10 text-redbean-primary">
                      <i className={`${icons[idx].icon} text-lg`} />
                    </span>
                    <span className="text-redbean-caramel text-sm font-semibold">
                      {icons[idx].label}
                    </span>
                  </div>
                  <h3
                    className="font-heading font-bold text-redbean-coffee mb-2"
                    style={{ fontSize: "1.25rem", lineHeight: 1.5 }}
                  >
                    {card.title}
                  </h3>
                  <p className="text-redbean-coffee/60 text-[1rem] leading-relaxed mb-4">
                    {card.desc}
                  </p>
                  <Link
                    to="/products"
                    className="inline-flex items-center gap-1 text-redbean-caramel font-medium text-[1rem] hover:text-redbean-primary transition-colors"
                  >
                    查看產品
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line" />
                    </span>
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}